export const CORNER_ROUNDED = "100%";
export const CORNER_EXTRA_LARGE = "28px";
export const CORNER_LARGE = "16px";
export const CORNER_MEDIUM = "12px";
export const CORNER_SMALL = "8px";
export const CORNER_EXTRA_SMALL = "4px";
